import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--settings" icon='settings'>{ children ? children : 'Settings' }</Button>
}